import React, { useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import { Link } from 'react-router-dom';
import { interviewNumbering, learningAjahnNumbering } from '../../utils/constant';
import { useTranslation } from 'react-i18next';
import { getInterviewForm } from '../../services/interview';
import { AiOutlineLoading } from 'react-icons/ai';
import { Trans } from 'react-i18next';
import dayjs from 'dayjs';
import { errorToast } from '../../utils/errorHandling';
import { getActiveCourseAjahn } from '../../services/settings';

const base_url = process.env.REACT_APP_BASE_URL

const ViewInterview = () => {
    const [interviewAjahnsList, setInterviewAjahnsList] = useState([]);
    const [learningAjahnsList, setLearningAjahnsList] = useState([]);
    const [inPersonAjahnsList, setInPersonAjahnsList] = useState([]);
    const [onlineAjahnsList, setOnlineAjahnsList] = useState([]);
    const { t } = useTranslation();
    const [selectedAjahn, setSelectedAjahn] = useState([]);
    const [selectedLearningAjahn, setSelectedLearningAjahn] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState("");
    const [role, setRole] = useState(null);
    const languageSelected = localStorage.getItem("i18nextLng");
    const [courseData, setCourseData] = useState(
        localStorage.getItem("courseData")
            ? JSON.parse(localStorage.getItem("courseData"))
            : null
    );

    const fetchInterview = async () => {
        try {
            const data = await getInterviewForm();
            if (data) {
                setFormData(data);
                setSelectedAjahn([
                    data.first_choice || "",
                    data.second_choice || "",
                    data.third_choice || "",
                    data.fourth_choice || "",
                    data.fifth_choice || "",
                    data.sixth_choice || "",
                    data.seventh_choice || "",
                    data.eighth_choice || "",
                    data.ninth_choice || "",
                    data.tenth_choice || ""
                ]);

                setSelectedLearningAjahn([
                    data.first_choice_learning || "",
                    data.second_choice_learning || "",
                    data.third_choice_learning || "",
                    data.fourth_choice_learning || "",
                    data.fifth_choice_learning || ""
                ]);
                setRole(localStorage.getItem("retreat_language") ? JSON.parse(localStorage.getItem("retreat_language")) : "");
            }
        } catch (error) {
            throw (error);
        }
    };

    const fetchAjahn = async () => {
        try {
            setIsLoading(true);
            const response = await getActiveCourseAjahn();
            if (response.length > 0) {
                setLearningAjahnsList(response.filter(e => e.is_learning == 1));
                setInterviewAjahnsList(response.filter(e => e.is_interview == 1));
                setInPersonAjahnsList(response.filter(e => e.mode === "In-person"));
                setOnlineAjahnsList(response.filter(e => e.mode === "Online"));
            }
            return true;
        } catch (error) {
            throw (error);
        }
    };

    useEffect(() => {
        const appInitiate = async () => {
            try {
                await fetchAjahn();
                await fetchInterview();
            } catch (error) {
                errorToast(error, t('general.ActionFailed'), t)
            } finally {
                setIsLoading(false);
            }
        }

        appInitiate();
    }, []);

    return (
        <>
            {formData === "" ?
                <div className='info-container'>
                    <h3>{t("interview.BigTitle")}</h3>
                    <p>
                        {
                            languageSelected === 'en' ?
                                courseData.course_ename
                                :
                                courseData.course_cname
                        }
                    </p>

                    {isLoading ?
                        <>
                            <AiOutlineLoading className='spin' />
                            <p>{t("interview.Loadinginterview")}</p>
                        </>
                        :
                        <>
                            <p style={{ "color": "#ff0000" }}>
                                <Trans key="accomodation" html="br:<br/>">
                                    <br />{t("interview.EmptyInterviewForm")}
                                </Trans>

                            </p>
                            <div className='action-buttons'>
                                <Link to={`${base_url}/retreat-interview`}>
                                    <Button
                                        buttonStyle='btn--primary'
                                        buttonSize='btn--small'
                                    >{t("general.FormSubmit")}</Button>
                                </Link>
                            </div>
                        </>
                    }
                </div>
                :
                <>
                    <div className='info-container'>
                        <h3>{t("interview.BigTitle")}</h3>
                        <p>
                            {
                                languageSelected === 'en' ?
                                    courseData.course_ename
                                    :
                                    courseData.course_cname
                            }
                        </p>
                        {formData.is_interview === "1" &&
                            <div className='action-buttons'>
                                <Link to={`${base_url}/retreat-interview-question`}>
                                    <Button
                                        buttonStyle='btn--primary'
                                        buttonSize='btn--small'
                                    >{t("general.QuestionSubmit")}
                                    </Button>
                                </Link>
                            </div>
                        }
                    </div>

                    <div className='form-wrapper mt-3'>
                        <h3 className='mt-2'>{t("interview.interviewResult")}</h3>
                        {formData.is_interview === "1" ?
                            <p>{t("interview.Display")}
                                <span className='error'> {t("interview.HallNum")}</span> {t("interview.and")}<span className='error'> {t("interview.INTdatetime")}</span>
                            </p>
                            :
                            <p>{t("interview.displayLearningAjahn")}</p>
                        }
                        <table className="table table-light">
                            <tbody>
                                {
                                    role !== "English" ?
                                        <tr>
                                            <th>{t("interview.Learning")}</th>
                                            <td>
                                                {
                                                    (formData.learning_ajahn && learningAjahnsList.length > 0) ?
                                                        languageSelected === 'en' ?
                                                            learningAjahnsList.find((item) => item.id == formData.learning_ajahn)?.ajahn_ename
                                                            :
                                                            learningAjahnsList.find((item) => item.id == formData.learning_ajahn)?.ajahn_cname
                                                        :
                                                        t("interview.DecideYET")
                                                }
                                            </td>
                                        </tr>
                                        :
                                        <tr>
                                            <th>{t("interview.Learning")}</th>
                                            <td>
                                                {t("Constant.English_Group")}
                                            </td>
                                        </tr>
                                }

                                {formData.is_interview === "1" &&
                                    <>
                                        <tr>
                                            <th>{t("interview.AssignINT")}</th>
                                            <td>
                                                {
                                                    (formData.interview_ajahn && interviewAjahnsList.length > 0) ?
                                                        formData.interview_ajahn === "None" ?
                                                            t("Constant.None")
                                                            :
                                                            languageSelected === "en" ?
                                                                interviewAjahnsList.find((item) => item.id == formData.interview_ajahn)?.ajahn_ename
                                                                :
                                                                interviewAjahnsList.find((item) => item.id == formData.interview_ajahn)?.ajahn_cname
                                                        :
                                                        t("interview.DecideYET")
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{t("interview.DateTime")}</th>
                                            <td>
                                                {
                                                    formData.interview_ajahn ?
                                                        formData.interview_ajahn === "None" ?
                                                            t("Constant.None")
                                                            :
                                                            languageSelected === "en" ?
                                                                dayjs(formData.interview_datetime).format("D MMMM YYYY (dddd) h:mm A")
                                                                :
                                                                dayjs.utc(formData.interview_datetime)
                                                                    .locale("zh-cn")
                                                                    .format("YYYY年M月D日 (dddd) A h:mm")
                                                        :
                                                        t("interview.DecideYET")
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{t("interview.INThall")}</th>
                                            <td>{formData.interview_hall || t("interview.DecideYET")}</td>
                                        </tr>
                                    </>
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className='form-wrapper'>
                        <form>
                            <div className='form-section-2'>
                                <div className='section-title'>
                                    <h4 className='mb-0'>{t("interview.Int_INFO")}</h4>
                                </div>
                                <p className='mt-3'><strong>{t("interview.Int_QUO")}</strong></p>
                                <ol>
                                    {interviewAjahnsList.map((i, index) => (
                                        <li key={index}>
                                            {localStorage.getItem("i18nextLng") === 'en' ? i.ajahn_ename : i.ajahn_cname}
                                            &nbsp;:&nbsp;
                                            {i.interview_pax} {t("Constant.PAX")}
                                        </li>
                                    ))}
                                </ol>
                                {role !== "English" &&
                                    <>
                                        <label>{t("interview.selectLearningAjahn")}</label>
                                        <table className="table table-light" style={{ "fontSize": "13px", "maxWidth": "800px" }}>
                                            <thead>
                                                <tr>
                                                    <th scope="col">{t("interview.choice")}</th>
                                                    <th scope="col">{t("interview.Ajahn")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {learningAjahnNumbering(t).map((i, index) => (
                                                    <tr key={index}>
                                                        <td>{i.displayNumbering}</td>
                                                        <td>
                                                            {
                                                                localStorage.getItem("i18nextLng") === 'en' ?
                                                                    learningAjahnsList.find((item) => item.ajahn_ename === selectedLearningAjahn[index]).ajahn_ename
                                                                    :
                                                                    learningAjahnsList.find((item) => item.ajahn_ename === selectedLearningAjahn[index]).ajahn_cname
                                                            }
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>
                                }
                                <div className="form-item">
                                    <label>{t("interview.q1")}
                                        <span style={{ "color": "#ff0000" }}>*</span></label>
                                    <div className='radio'>
                                        <input className="form-check-input" type="radio" name="is_interview" id="1" checked={formData.is_interview === "1"} readOnly />
                                        <p className='radioLabel mb-0'>{t("general.yes")}</p>
                                    </div>
                                    <div className='radio'>
                                        <input className="form-check-input" type="radio" name="is_interview" id="0" checked={formData.is_interview === "0"} readOnly />
                                        <p className='radioLabel mb-0'>{t("general.no")}</p>
                                    </div>
                                </div>
                                {formData.is_interview === "1" && (
                                    <>
                                        <label>{t("interview.selectInterviewAjahn")}</label>
                                        <table className="table table-light" style={{ "fontSize": "13px", "maxWidth": "800px" }}>
                                            <thead>
                                                <tr>
                                                    <th scope="col">{t("interview.choice")}</th>
                                                    <th scope="col">{t("interview.Ajahn")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {interviewNumbering(t).map((i, index) => (
                                                    <tr key={index}>
                                                        <td>{i.displayNumbering}</td>
                                                        <td>
                                                            {
                                                                localStorage.getItem("i18nextLng") === 'en' ?
                                                                    interviewAjahnsList.find((item) => item.ajahn_ename === selectedAjahn[index]).ajahn_ename
                                                                    :
                                                                    interviewAjahnsList.find((item) => item.ajahn_ename === selectedAjahn[index]).ajahn_cname
                                                            }
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </>
                                )}
                            </div>
                        </form>
                    </div>
                </>
            }
        </>
    )
}

export default ViewInterview